import React, { useEffect, useMemo, useRef, useState } from "react"
import { getHandlerTableChange, sortCaret } from "../../../../../_metronic/_helpers"
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator"
import { Pagination } from "../../../../../_metronic/_partials/controls"
import BootstrapTable from "react-bootstrap-table-next"
import { usePharmaReceivingUIContext } from "./PharmaReceivingUIContext"
import * as actions from "../../_redux/pharma-deliveries/pharmaDeliveriesActions";
import * as uiHelpers from "./PharmaReceivingUIHelpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import * as columnFormatters from "./column-formatters";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"
import * as ordersCrud from '../../../Sales/_redux/orders/ordersCrud'
import { errorMsg } from "../../../Global/helpers"
import { OrderScanner } from "./OrderScanner"
import { OrderPickingDialog } from "./OrderPickingDialog"

const capitalizeWords = (name) => {
  if (!name || typeof name !== "string") return "";

  return name
    .trim()                  
    .toLowerCase()
    .split(/\s+/)            
    .filter(Boolean)         
    .map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};

export const PharmaReceivingTable = ({setShowConfirmationDialog})=>{
    // const pharmaReceivingUIContext = usePharmaReceivingUIContext();
    const [data, setData] = useState([])
    const [showPickingModal, setShowPickingModal] = useState(false)
    const {ordersQueryParams, setOrdersQueryParams, openEditOrderPage, setOrderForEdit} = usePharmaReceivingUIContext()
    
    // const pharmaReceivingUIProps = useMemo(() => {
    //     return {
    //         queryParams: pharmaReceivingUIContext.ordersQueryParams,
    //         setQueryParams: pharmaReceivingUIContext.setOrdersQueryParams,
    //         openEditOrderPage: pharmaReceivingUIContext.openEditOrderPage,
    //         setOrderForEdit: pharmaReceivingUIContext.setOrderForEdit
    //     };
    // }, [pharmaReceivingUIContext]);

    // Getting curret state of orders list from store (Redux)
    const { reportState } = useSelector(
        (state) => ({ reportState: state.pharmaDeliveries }),
        shallowEqual
    );
    const { totalCount, entities, listLoading, ordersUpdated:reportUpdated } = reportState;

    const { orderState } = useSelector(
        (state) => ({ orderState: state.orders }),
        shallowEqual
    );
    const { ordersUpdated:orderUpdated } = orderState;

    const receive = async (row)=>{
        try{
            const resp = await ordersCrud.getOrderById(row?.id)
            setOrderForEdit(resp.data.results)
            setShowConfirmationDialog(true)

        }
        catch(err){
            console.log(err)
            errorMsg("Error al leer pedido") 
        }
    }
    const hidePickingModal = async ()=>{
        setShowPickingModal(false)
        dispatch(actions.fetchOrders(ordersQueryParams));
    }

    const cancel = (row)=>{
        console.log(row)
    }


    const pickOrders = ()=>{
        setShowPickingModal(true)
    }
    
    const dispatch = useDispatch();

    const columns = [
        {
          dataField: "id",
          text: "ID",
          sort: true,
          sortCaret: sortCaret,
        },
        {
        dataField: "customer",
        text: "Cliente",
        //filter: textFilter(),
        sort: true,
        sortCaret: sortCaret,
        formatter: (cellContent, row) => (
            <span style={{  }}>
            <p style={{ marginBottom:'0' }}>{ capitalizeWords(cellContent?.first_name) }</p>
            <p style={{ marginBottom:'0' }}>{ capitalizeWords(cellContent?.last_name) }</p>
            { (row.billing?.last_name?.toLowerCase()?.trim()!=cellContent?.last_name?.toLowerCase()?.trim() && 
                row.billing?.first_name?.toLowerCase()?.trim()!=cellContent?.first_name?.toLowerCase()?.trim())? 
                <p style={{ marginBottom:'0' }}>
                (Fc: { capitalizeWords(row.billing?.first_name) } { capitalizeWords(row.billing?.last_name) })
                </p>: ""
            }
            </span>
        )
        },
        {
        dataField: "billing.tax.number",
        text: "Documento",
        sort: true,
        sortCaret: sortCaret,
        },
        {
        dataField: "source.name",
        text: "Origen",
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.SourceColumnFormatter
        },

        {
        dataField: "order_creation",
        text: "Fecha",
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.DateColumnFormatter
        },
        {
        dataField: "shipping.type.name",
        text: "Envío",
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.ShippingTypeColumnFormatter
        },        
        {
        dataField: "entregar",
        text: "",
        dummyField: true,
        headerClasses: "text-center",
        classes: "text-center",
        formatter: (cell, row)=>{
            
            return (
            <>
            {!row.delivered_date &&
                <>
                    {/* <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Imprimir Orden</Tooltip>} >
                        <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1" onClick={() => {printGuide(row)}} > <span><i className="fa fa-print text-info"></i></span> </a>
                    </OverlayTrigger> */}

                {/* <ComponentToPrintWrapper row={row} ></ComponentToPrintWrapper> */}
    
                    <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Recibir órden</Tooltip>} >
                    <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1" onClick={() => {receive(row)}} > <span><i className="fas fa-cart-arrow-down text-primary"></i></span> </a>
                    </OverlayTrigger>
                    {/* { Boolean( row.business_unit?.id != 3 ) && //por ahora excluímos mitest
                    <OverlayTrigger overlay={<Tooltip id="waves-print-tooltip">Cancelar Orden</Tooltip>} >
                        <a className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1" onClick={() => {cancel(row)}} > <span><i className="fa fa-trash text-danger"></i></span> </a>
                    </OverlayTrigger>
                    } */}
                </>

            }
            
            </>
        )
        },
        },        
    ]

    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: ordersQueryParams.pageSize,
        page: ordersQueryParams.pageNumber,
        paginationTotalRenderer: (from, to, size) => (
          <span className="react-bootstrap-table-pagination-total">
            Mostrando { from } a { to } de { size } Resultados
          </span>
        )
    };
    
    useEffect (()=>{
        //solo se queda con los que tienen ready_to_pickup en null
        setData(entities?.filter(s => !s.ready_to_pickup) || [])
    }, [entities])

    // useEffect(() => {
    //     dispatch(actions.fetchOrders(ordersQueryParams));
    // }, [ ordersQueryParams, reportUpdated, orderUpdated]);

      useEffect(() => {
        const controller = new AbortController();
    
        dispatch(actions.fetchOrders(
          ordersQueryParams,
          controller.signal
        ));
    
        return () => {
          controller.abort(); // se cancela cuando cambian deps o unmount
        };
      }, [ordersQueryParams, reportUpdated, orderUpdated]);

    return (
        <>

            <OrderPickingDialog show={showPickingModal} onHide={hidePickingModal} ordersAvailable = {data.map(d=>d.id)} />

            <button type="button" onClick={pickOrders} className="btn btn-light float-right m-2" > 
                <i className="fa fa-barcode text-success"></i> Pickear órdenes
            </button>

            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                return (

                    <Pagination
                        isLoading={listLoading}
                        paginationProps={paginationProps}
                    >

                    <BootstrapTable
                        rowStyle={ { fontSize: "smaller" } }
                        wrapperClasses="table-responsive"
                        classes="table table-head-custom table-vertical-center overflow-hidden"
                        bootstrap4
                        bordered={false}
                        condensed={false}
                        // striped={true}
                        remote //</Pagination>= { { filter: true } }
                        //filter={ filterFactory() }
                        keyField="id"
                        data={entities === null ? [] : data}
                        columns={columns}
                        // selectRow={ selectRow } 
                        onTableChange={ getHandlerTableChange( setOrdersQueryParams) }
                        {...paginationTableProps}
                    >

                    </BootstrapTable>

                    </Pagination>

                );
                }}
            </PaginationProvider>
        
        </>
    )
}





